/**
 * @desc 判断当前拖动所在区域是否在一个指定的元素的范围内
 */
export function isInElement(e: DragEvent, flag = '[data-is-folder]') {
  const target = e.target as HTMLElement
  const element = target.closest(flag) as HTMLElement
  if (!element) return null
  // 只考虑本身
  if (e.relatedTarget && target.contains(e.relatedTarget as Node)) {
    return null
  }
  return element.contains(target) ? element : null
}
